import { render, staticRenderFns } from "./MenuChooseBox.vue?vue&type=template&id=7849ab11&scoped=true&"
import script from "./MenuChooseBox.vue?vue&type=script&lang=js&"
export * from "./MenuChooseBox.vue?vue&type=script&lang=js&"
import style0 from "./MenuChooseBox.vue?vue&type=style&index=0&id=7849ab11&lang=scss&scoped=true&"
import style1 from "./MenuChooseBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../salespro-dev/salespro-dev/sources/client/salespro-dev-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7849ab11",
  null
  
)

export default component.exports